import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    autoOpenDefault: true, // default for all users
    isPluginOpen: null,
};
const slice = createSlice({
    name: 'SETTINGS',
    initialState,
    reducers: {
        set(state, action) {
            const settings = action.payload;
            return Object.assign(Object.assign({}, state), settings);
        },
        setAutoOpenDefault(state, action) {
            state.autoOpenDefault = action.payload;
        },
        setIsPluginOpen(state, action) {
            state.isPluginOpen = action.payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
